import { useEffect, useState } from 'react'
import { reportsApi } from '../../services'
import type { ReportMetadata } from '../../types'
import { logger } from '../../utils/logger'

interface UseReportsDataResult {
  reports: ReportMetadata[]
  loading: boolean
  error: string | null
}

export function useReportsData(): UseReportsDataResult {
  const [reports, setReports] = useState<ReportMetadata[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchReports = async (): Promise<void> => {
      try {
        setLoading(true)
        const data = await reportsApi.listReports()
        setReports(data)
      } catch (err) {
        logger.error('ReportsHubPage', 'Failed to fetch reports', err)
        setError('Failed to load reports. Please try again.')
      } finally {
        setLoading(false)
      }
    }
    void fetchReports()
  }, [])

  return { reports, loading, error }
}
